import { Upload } from 'lucide-react'
import { type RefObject, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import type { RecordingFileProblem } from '../questioning/recording-types'

export function VoiceFilePicker({
  onFile,
  inputRef,
}: {
  onFile: (file: File) => RecordingFileProblem | null
  inputRef: RefObject<HTMLInputElement | null>
}) {
  const { t } = useTranslation()
  const [problem, setProblem] = useState<RecordingFileProblem | null>(null)
  return (
    <div className="mb-5 space-y-2 border-b border-border pb-5">
      <Button
        variant="outline"
        className="w-full justify-start gap-2"
        onClick={() => inputRef.current?.click()}
      >
        <Upload aria-hidden className="size-4" />
        {t('humint.voice.sample.file.upload')}
      </Button>
      <input
        ref={inputRef}
        type="file"
        className="hidden"
        tabIndex={-1}
        accept=".webm,.m4a,.mp4,.3gp,.ogg,.oga,.opus,.mp3,.wav,.flac,.amr"
        aria-label={t('humint.voice.sample.file.upload')}
        onChange={event => {
          const file = event.currentTarget.files?.[0]
          event.currentTarget.value = ''
          if (file) setProblem(onFile(file))
        }}
      />
      <p className="text-sm text-muted-foreground">{t('humint.voice.sample.file.hint')}</p>
      {problem && (
        <p role="alert" className="text-sm text-destructive">
          {t(`humint.voice.sample.file.errors.${problem}`)}
        </p>
      )}
    </div>
  )
}

/** File imports have no microphone instructions. */
export function VoiceFileGuide() {
  const { t } = useTranslation()
  return (
    <div className="space-y-3">
      <h3 className="font-semibold">{t('humint.voice.sample.file.title')}</h3>
      <p className="text-sm leading-relaxed text-muted-foreground">
        {t('humint.voice.sample.file.hint')}
      </p>
    </div>
  )
}
